import { render, staticRenderFns } from "./answerAnalysis.vue?vue&type=template&id=372def04&"
import script from "./answerAnalysis.vue?vue&type=script&lang=js&"
export * from "./answerAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports